import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'novus-sidebar-layout',
  templateUrl: './sidebar-layout.component.html',
  styleUrls: ['./sidebar-layout.component.css']
})
export class SidebarLayoutComponent {

  constructor() { }

}
